module.exports = __webpack_public_path__ + "img/5.faa028b4.jpg";